import React from 'react';
import clsx from 'clsx';
import styles from './QuoteActions.module.scss';
import { QuoteBuyButton, CompareBrokersButton } from '@benzinga/quotes-ui';
import type { ButtonVariant } from '@benzinga/core-ui';
import { GetReportButton } from '@benzinga/ticker-ui';

interface QuoteActionsProps {
  className?: string;
  symbol: string;
  isCrypto?: boolean;
  onClick?: (metaData: string) => void;
  quoteBuyButtonVariant?: ButtonVariant;
  compareBrokersButtonVariant?: ButtonVariant;
  getReportButtonVariant?: ButtonVariant;
  showGetReportButton?: boolean;
  showQuoteBuyButton?: boolean;
  showCompareBrokersButton?: boolean;
}

export const QuoteActions: React.FC<QuoteActionsProps> = ({
  className,
  compareBrokersButtonVariant,
  getReportButtonVariant,
  isCrypto,
  quoteBuyButtonVariant,
  showCompareBrokersButton = true,
  showGetReportButton = true,
  showQuoteBuyButton = true,
  symbol,
}) => {
  return (
    <div className={clsx(styles.quoteActionsContainer, 'quote-actions-container', className)}>
      {showGetReportButton && !isCrypto && <GetReportButton ticker={symbol} variant={getReportButtonVariant} />}
      {showQuoteBuyButton && (
        <QuoteBuyButton
          link={`https://www.benzinga.com/go/trade-with-public/?pl=buy&utm_source=/quote/${symbol}&symbol=${symbol}`}
          symbol={symbol}
          variant={quoteBuyButtonVariant}
        />
      )}
      {showCompareBrokersButton && (
        <CompareBrokersButton
          link={
            isCrypto
              ? 'https://www.benzinga.com/money/best-cryptocurrency-brokers'
              : 'https://www.benzinga.com/money/compare-online-brokers'
          }
          symbol={symbol}
          variant={compareBrokersButtonVariant}
        />
      )}
    </div>
  );
};

